module.exports = __webpack_public_path__ + "img/icon-ship-mask.5dfdc95.png";